import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Analytics from 'analytics-opencare';

import { useAnalyticsService } from 'services/AnalyticsService';

import { STEP_KEY, generateStepAnalytics } from '../../utils';
import { StepWrapper } from '../../styled-components';
import {
  Title,
  Subtitle,
  OptionBlock,
} from '../../../common/styled-components';
import SingleSelect from '../../../common/components/SingleSelect/SingleSelect';
import { useFunnelStorage } from '../../storage/Storage';

import { options } from './constants';

const analytics = new Analytics();

const Gender = ({ position, moveToNextStep }) => {
  const storage = useFunnelStorage();

  const analyticsService = useAnalyticsService();

  const savedGender = storage.get(STEP_KEY.GENDER);

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_gender',
      ...generateStepAnalytics(position, storage),
      ...analyticsService.analyticsData,
    });
  }, []);

  const handleClick = (value, index) => {
    analytics.trackClick({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_gender',
      name: 'wizard',
      section: 'dentist-gender',
      position: [index + 1],
      ...generateStepAnalytics(position, storage, {
        response: value,
      }),
    });

    storage.save(STEP_KEY.GENDER, value, true);
    moveToNextStep();
  };

  return (
    <div>
      <Title id="title">Is the gender of your dentist important to you?</Title>
      <Subtitle>
        There's no right or wrong answer! If you have a preference, we'll take
        it into account.
      </Subtitle>
      <StepWrapper>
        <form>
          <OptionBlock row={3}>
            {options.map((option, i) => (
              <SingleSelect
                key={option.id}
                id={option.id}
                title={option.title}
                describedBy="title"
                onChange={() => handleClick(option.id, i)}
                Icon={option.icon}
                selected={savedGender === option.id}
              />
            ))}
          </OptionBlock>
        </form>
      </StepWrapper>
    </div>
  );
};

Gender.defaultProps = {
  position: '',
};

Gender.propTypes = {
  position: PropTypes.string,
  moveToNextStep: PropTypes.func.isRequired,
};

export default Gender;
